var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSleepStages = function SvgSleepStages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3h1a1 1 0 0 1 1 1v4h2V5a1 1 0 0 1 1-1h1V1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3h1a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V6h-1a1 1 0 0 1-1-1V2h-2v3a1 1 0 0 1-1 1h-1v4a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V6H7a1 1 0 0 1-1-1V2H4v3a1 1 0 0 1-1 1H2v3a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1h1z"
  })));
};
export default SvgSleepStages;